import { render, staticRenderFns } from "./collectionEditTabInformation.vue?vue&type=template&id=98d92320&scoped=true&"
import script from "./collectionEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./collectionEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./collectionEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d92320",
  null
  
)

export default component.exports